import React from 'react';
import SelectedColumnList from './SelectedColumnList';

const SummaryTableParametersComponent = () => (
  <div className="content-item">
    <div>
      <SelectedColumnList />
    </div>
  </div>
);
export default SummaryTableParametersComponent;
